import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "fullcalendar/dist/fullcalendar.css";
import config from "./config/constants";
import "animate.css";
import { library } from "@fortawesome/fontawesome-svg-core";

import VueConfetti from 'vue-confetti';
Vue.use(VueConfetti)

import {
  faTimesCircle,
  faTimes,
  faClock,
  faUserClock,
  faMapMarkerAlt,
  faUser,
  faEuroSign,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faBars,
  faEllipsisH,
  faPlay,
  faCheck,
  faLock,
  faEye,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-pro/css/all.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "slick-carousel/slick/slick.css";
import VueDateFns from "vue-date-fns";
import IdleVue from "idle-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: process.env.VUE_APP_VERSION,
  environment: process.env.NODE_ENV,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "spectrum.life", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});

// Vue.use(VueGtag, {
//   config: { id: process.env.VUE_APP_GA_TRACKING_ID },
//   appName: 'UP-SPA',
// }, router);

Vue.component("v-select", vSelect);

const eventsHub = new Vue();
const options = { eventEmitter: eventsHub, idleTime: 7200000 };


Vue.use(IdleVue, options);

Vue.use(VueDateFns);
library.add(
  faTimesCircle,
  faTimes,
  faClock,
  faUserClock,
  faMapMarkerAlt,
  faUser,
  faEuroSign,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faBars,
  faEllipsisH,
  faPlay,
  faCheck,
  faLock,
  faEye,
  faEyeSlash
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(BootstrapVue);

Vue.use(VueAxios, axios);
Vue.use(config);

Vue.config.productionTip = false;

import './mixins/generalMixin'

import AnalyticsPlugin from "./analytics";

Vue.use(AnalyticsPlugin);

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");
